import { Popover as AlphaPopover } from '@oneaudi/unified-web-alpha-components';

export default AlphaPopover;
